import { render, staticRenderFns } from "./FilterBlock.vue?vue&type=template&id=cf235dee&scoped=true&"
import script from "./FilterBlock.vue?vue&type=script&lang=js&"
export * from "./FilterBlock.vue?vue&type=script&lang=js&"
import style0 from "./FilterBlock.vue?vue&type=style&index=0&id=cf235dee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf235dee",
  null
  
)

export default component.exports